<div id="locationMap" #locationMapContainer style="width: 100%; height: 400px"></div>
